import { render, staticRenderFns } from "./PointsHistoryProcessed.vue?vue&type=template&id=5c6aa212"
import script from "./PointsHistoryProcessed.vue?vue&type=script&lang=js"
export * from "./PointsHistoryProcessed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports